
const DEFAULT_PROJECT_ID = "";


const mapRatingToRag = (rating) => {
    if (rating === 4) return "G";
    if (rating === 3) return "A";
    if (rating === 2) return "R";
    if (rating === 1) return "B";

    return "B";
};

function normalizeRagValue(value) {
  if (value === null || value === undefined) return "B";
  const normalized = String(value).trim().toUpperCase();
  if (normalized === "G" || normalized === "4") return "G";
  if (normalized === "A" || normalized === "3") return "A";
  if (normalized === "R" || normalized === "2") return "R";
  return "B";
}

export function createFallbackProjectMeta(id) {
  return {
    id,
    name: "Project",
    contractCategory: "T & M",
    pm: "-",
    sponsor: "-",
    department: "-",
    health: "B",
    budget_spent: 0,
    budget_total: 0,
    completion: 0,
  };
}

/** Maps a raw project-health search record into the partial shape used to merge into project review state. */
export function mapApiProjectToProject(item) {
  return {
    id: String(item.projectId || item.projectIdString || item.projectIdValue || "-"),
    name: String(item.projectName || item.name || "-"),
    pm: String(item.pmName || item.pm || "-"),
    sponsor: String(item.dmName || item.sponsor || "-"),
    department: String(item.portfolio || item.department || "-"),
    health: mapRatingToRag(item.pmoRating),
    schedule: normalizeRagValue(item.schedule),
    budget: normalizeRagValue(item.invoiceStatus ?? item.budgetStatus),
    scope: normalizeRagValue(item.scope),
    risk: normalizeRagValue(item.riskIssue),
    quality: normalizeRagValue(item.quality),
    resources: normalizeRagValue(item.resource),
    ebitda: item.ebitda ?? null,
    totalContractValue: (item.totalContractValue ?? item.contractValue ?? item.tcv),
    completion: Number(item.completedPercentage ?? item.completion ?? 0),
    budget_spent: Number(item.budget_spent ?? item.budgetSpent ?? 0),
    budget_total: Number(item.budget_total ?? item.budgetTotal ?? 0),
    completedPercentage: item.completedPercentage ?? null,
    supportFromWm: item.supportFromWm ?? null,
    supportFromUst: item.supportFromUst ?? null,
  };
}

/** Transforms raw value-add API items into table-ready rows, dropping soft-deleted entries. */
export function mapApiValueAddItems(items, ownerFallback) {
  return items
    .filter((item) => !item.deleted)
    .map((item) => ({
      id: item.valueAddId || String(Math.random()),
      title: item.title || "",
      description: item.description || "",
      owner: ownerFallback,
      category: item.category || "",
      starred: false,
    }));
}

export { DEFAULT_PROJECT_ID };
